import { render } from "./ParcelInfoForm.vue?vue&type=template&id=278a925f&scoped=true"
import script from "./ParcelInfoForm.vue?vue&type=script&lang=js"
export * from "./ParcelInfoForm.vue?vue&type=script&lang=js"

import "./ParcelInfoForm.vue?vue&type=style&index=0&id=278a925f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-278a925f"]])

export default __exports__